import React, { useState, useEffect } from "react";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import Modal from "react-bootstrap/Modal";
import { SlOption, SlSelect, SlDrawer, SlButton, SlInput, SlIcon, SlIconButton, SlTooltip } from '@shoelace-style/shoelace/dist/react';
import Button from "react-bootstrap/Button";
import { Form as selectForm } from "react-bootstrap";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import { useFormik } from "formik";
import { stateOptions } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import { formatDateWithTime } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import { useDispatch, useSelector } from 'react-redux';
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import { debounce } from "../../utils/Debounce";
import { orderTablePermissions } from "../../utils/constants";
import Select from 'react-select';
import PendingRequestModal from "../MakerChecker/components/PendingRequestModal";

const initialAdvertiser = {
  // advertiserType: "",
  company_name: "",
  advertiser_name: "",
  mobile_no: "",
  email: "",
  password: "",
  permissions: []
  // gst_no: "",
  // pan_no: "",
  // state_id: "",
  // district_id: "",
  // mandal_id: "",
  // village_id: "",
  // address: "",
  // category_id: "",
  // isagency: false,
  // commission: 0,
  // Account_number: "",
  // Ifsc_code: "",
};


let initialValues = JSON.parse(JSON.stringify(initialAdvertiser));

const AdvertiserSchema = Yup.object().shape({
  // advertiserType: Yup.string().required("Advertiser Type is required"),
  // company_name: Yup.string().matches(/^[a-zA-Z0-9][a-zA-Z0-9\s.]*$/, "Company name can't start with white space or special charaters").required("Company Name is required"),
  company_name: Yup.string().required("Company Name is required"),
  advertiser_name: Yup.string().required(" Name is required"),
  mobile_no: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
    .min(10, "Mobile must be 10 digits")
    .max(10, "Mobile must be 10 digits")
    .required("Mobile Number is required"),
  email: Yup.string().email().required("Email is required"),
  // gst_no: Yup.string()
  //   .matches(
  //     /[0-9]{2}[A-Z]{5}[0-9]{4}[A-z][0-9][Z][0-9]/,
  //     "Invalid GST number - case sensitive "
  //   )
  //   .optional(),
  // pan_no: Yup.string()
  //   .matches(/[A-Z]{5}[0-9]{4}[A-Z]/, "Invalid PAN number - case sensitive")
  //   .optional(),
  // Account_number: Yup.string().matches(/[0-9]{9,18}/, "Account Number Invalid").optional(),
  // Ifsc_code: Yup.string().matches(/[A-Z]{4}0[A-Z0-9]{6}/, "Invalid Ifsc Code").optional(),
  // address: Yup.string().optional(),
  // isagency: Yup.boolean(),
  // commission: Yup.number().when("isagency", {
  //   is: (isagency) => isagency,
  //   then: Yup.number()
  //     .required("Commission is required")
  //     .min(1, "Must be greater than or equal to 1")
  //     .max(100, "Must be less than or equal to 100"),
  // }).nullable(),
});

function Advertiser() {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState(-1);
  const [agency, setAgency] = useState(-1);
  // const [itemOffset, setItemOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [flag, setFlag] = useState("");

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  // const [date, setDate] = useState('');
  const [open, setOpen] = useState(false);
  const [advid, setadvid] = useState("");
  const [search, setSearch] = useState("");

  const [selectedMcId,setSelectedMcId] = useState('');
  const handleCloseModal = () => {
      setSelectedMcId(null);
  };

  const HeaderSearch = useSelector(state => state.Head.adssearch)

  function handleSales(items) {
    setOpen(true);
    loadSales();
  }
  const handle = () => {
    setOpen(false);
    setView(false);
    // setSub(false)
    setDisplay(false);
  };

  const [sales, setSales] = useState([]);
  const [sales_id, setSalesId] = useState(-1);
  const [category, setCategory] = useState([]);
  const [advtype, setAdvType] = useState("");
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [mandals, setMandals] = useState([]);
  const [villages, setVillages] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [view, setView] = useState(false);
  const [types, setTypes] = useState([]);
  const [res, setRes] = useState({});
  const [display, setDisplay] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [otp, setOtp] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  function handleLocation(item) {
    setDisplay(true);
    setRes(item);
  }

  const handlePageClick = (event) => {
    // const newOffset = (event.selected * config.PER_PAGE) % data.length;
    // setItemOffset(newOffset);
    setCurrentPage(event.selected);
    loadData(search, event.selected, status);
    setOtp({});
  };

  const handleClose = () => {
    initialValues = JSON.parse(JSON.stringify(initialAdvertiser));
    formik.setValues(initialValues);
    setSelectedPermissions([]);
    setShow(false);
    setSubmit(false);
  };
  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }

  const loadData = async (
    searchString = "",
    page = 0,
    status = -1,
    // agency = -1
  ) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/user/advertisers/getAdvertisers`,
        method: "POST",
        responseType: "json",
        data: {
          page: page,
          limit: config.PER_PAGE,
          search: searchString,
          status: parseInt(status),
          // agency: parseInt(agency),
        },
      });
      setData(res.data.data.length ? res.data.data : []);
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      //Toast.error("Something went wrong")
      if (error?.response?.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0, status);
  }

  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0, status);
    setOtp({});

  };

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialAdvertiser)),
    validationSchema: AdvertiserSchema,
    onSubmit: async (values) => {
      // if (!values.isagency) values.commission = null;
      values.permissions = selectedPermissions;
      console.log(values)
      if (flag === "add") {
        try {
          let res = await api({
            url: `/user/advertisers`,
            method: "POST",
            responseType: "json",
            data: {...values,ref_table:"advertiser"},
          });
          if (res?.data?.code === 500) {
            Toast("error", res.data.message);
          } else if (res?.data?.code === 400) {
            Toast("error", res.data.message);
          } else {
            Toast("success", "Advertiser Add Request Sent Successfully");
            handleClose();
            setCurrentPage(0);
            setSearch("");
            setStatus(-1);
            // setAgency(-1);
            loadData(search, 0, status);
            setOtp({});
            setSelectedPermissions([]);
            formik.setFieldValue('permissions', []);
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong";
          Toast("error", er);
          if (error.response.status === 401) navigate("/");
        }
      }

      if (flag === "edit") {
        // if ((values.category_id === -1 || values.category_id === null) && category_id < 0) {
        //     Toast('error', " please select the category")
        // }
        // if ((values.state_id === -1 || values.state_id === null) && state_id < 0) {
        //     Toast('error', " Please select the State")
        // }
        // if ((values.district_id === -1 || values.district_id === null) && district_id < 0) {
        //     Toast('error', " Please select the District")
        // }
        // if ((values.mandal_id === -1 || values.mandal_id === null) && mandal_id < 0) {
        //     Toast('error', " Please select the Mandal")
        // }
        // if ((values.village_id === -1 || values.village_id === null) && village_id < 0) {
        //     Toast('error', " Please select the Village")
        // }
        try {
          // values.category_id = category_id
          // values.state_id = state_id
          // values.district_id = district_id
          // values.mandal_id = mandal_id
          // values.village_id = village_id
          // if (values.state_id === -1 || values.state_id === null) values.state_id = state_id
          // if (values.district_id === -1 || values.district_id === null) values.district_id = district_id
          // if (values.mandal_id === -1 || values.mandal_id === null) values.mandal_id = mandal_id
          // if (values.village_id === -1 || values.village_id === null) values.village_id = village_id
          values.advid = advid;
          let res = await api({
            url: `/user/advertisers/${advid}`,
            method: "PUT",
            responseType: "json",
            data: {...values,ref_table:"advertiser"},
          });
          if (res?.code === 200) {
            Toast("success", "Advertiser updated Successfully");
            loadData(search, currentPage, status);
            setOtp({});
            handleClose();
            values = JSON.parse(JSON.stringify(initialAdvertiser));
          } else {
            Toast("error", res?.data?.message);
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong";
          Toast("error", er);
          if (error.response.status === 401) navigate("/");
        }
      }
    },
  });

  const getStates = async () => {
    try {
      const response = await api({
        url: `/user/advertisers/getstates`,
        method: "GET",
        responseType: "json",
      });
      if (response?.data?.data) {
        setStates(response?.data?.data);
      }
    } catch (error) {
      console.log("error");
    }
  };
  const getTypes = async () => {
    try {
      const response = await api({
        url: `/user/advertisers/getadvtypes`,
        method: "GET",
        responseType: "json",
      });
      if (response?.data?.data) {
        setTypes(response?.data?.data);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const getCompanies = async () => {
    try {
      const response = await api({
        url: `/user/advertisers/getCompanies`,
        method: "GET",
        responseType: "json",
      });
      if (response?.data?.data) {
        setCompanies(response?.data?.data);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const getDistricts = async (state_id) => {
    try {
      let res = await api({
        url: `/user/advertisers/getdistricts`,
        method: "POST",
        responseType: "json",
        data: { state_id },
      });
      if (res.code === 200) {
        setDistricts(res.data);
      }
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };
  const getMandals = async (dist_id) => {
    try {
      let res = await api({
        url: `/user/advertisers/getmandals`,
        method: "POST",
        responseType: "json",
        data: { dist_id },
      });
      if (res?.code === 200) {
        setMandals(res.data);
      }
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };

  const getVillages = async (mandal_id) => {
    try {
      let res = await api({
        url: `/user/advertisers/getvillages`,
        method: "POST",
        responseType: "json",
        data: { mandal_id },
      });
      if (res.code === 200) {
        setVillages(res.data);
      }
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };

  const loadCategories = async () => {
    try {
      let res = await api({
        url: "/user/advertisers/campaign_categories",
        method: "GET",
        responseType: "json",
      });
      if (res?.data?.length) setCategory(res.data);
      else setCategory([]);
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const loadSales = async () => {
    try {
      let res = await api({
        url: "/user/sales_persons/getsales",
        method: "GET",
        responseType: "json",
      });
      setSales(res.data);
    } catch (error) {
      console.log(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const handleSalesSave = async () => {
    if (sales_id === -1) {
      Toast("error", " please select salesperson to assign ");
    } else {
      try {
        await api({
          url: `/user/advertisers/sales/${advid}`,
          method: "PUT",
          responseType: "json",
          data: {
            sales_person_id: parseInt(sales_id),
          },
        });
        Toast("success", "Sales Person assigned Succesfully");
        handle();
        loadData(search, currentPage, status);
        setSalesId(-1);
      } catch (error) {
        let er = error?.response?.message || "Something went wrong";
        Toast("error", er);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const handleShow = async (choose, item) => {
    if (choose === "add") {
      formik.setValues(item);
      setShow(true);
    }
    if (choose === "edit") {
      await loadCategories();
      initialValues.advertiser_name = item.advertiser_name;
      initialValues.email = item.email || "";
      initialValues.mobile_no = item.mobile_no;
      initialValues.password = item.password;
      // initialValues.gst_no = item.gst_no || "";
      // initialValues.pan_no = item.pan_no || "";
      await getCompanies();
      initialValues.company_name = item.company_id;
      // initialValues.state_id = item.state_id ? String(item.state_id) : "";
      // initialValues.Account_number = item.account || "";
      // initialValues.Ifsc_code = item.ifsc || "";
      // await getStates();
      // initialValues.state_name = item.state_name || "";
      // item.state_id && (await getDistricts(item.state_id));
      // initialValues.district_id = item.district_id ?  String(item.district_id) :  "";
      // initialValues.district_name = item.district_name || "";
      // item.district_id && (await getMandals(item.district_id));
      // initialValues.mandal_id = item.mandal_id ? String(item.mandal_id) : "";
      // initialValues.mandal_name = item.mandal_name || "";
      // item.mandal_id && (await getVillages(item.mandal_id));
      // initialValues.village_id = item.village_id ?  String(item.village_id) : "";
      // initialValues.village_name = item.village_name || "";
      // initialValues.address = item.address || "";
      // initialValues.category_name = item.category_name;
      // initialValues.category_id = item.category_id;
      // initialValues.isagency = item.isagency ? true : false;
      // initialValues.commission = item.commission || "";
      // initialValues.advertiserType = item.id;
      // await getTypes();
      let permissionsArray = [];
      if (item.permissions && item.permissions !== "") {
        const permissionsString = item.permissions.replace(/[{}"]/g, "");
        permissionsArray = permissionsString.split(",").map(permission => permission.trim());
      }
      initialValues.permissions = permissionsArray;
      initialValues.status = item.status;
      setSelectedPermissions(options.filter(option => permissionsArray.includes(option.value)));
      formik.setValues(initialValues);
      setShow(true);
    }
  };

  const onInputChange = (type, id) => {
    switch (type) {
      case "state_id":
        formik.setFieldValue(
          "state_name",
          stateOptions.find((j) => j.state_id === +id)?.state_name
        );
        formik.setFieldValue("mandal_id", "");
        formik.setFieldValue("mandal_name", "");
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        formik.setFieldValue("district_id", "");
        formik.setFieldValue("district_name", "");
        break;
      case "district_id":
        formik.setFieldValue(
          "district_name",
          districts.find((j) => j.dist_id === +id)?.dist_name
        );
        formik.setFieldValue("mandal_id", "");
        formik.setFieldValue("mandal_name", "");
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        break;
      case "mandal_id":
        formik.setFieldValue(
          "mandal_name",
          mandals.find((j) => j.mandal_id === +id)?.mandal_name
        );
        formik.setFieldValue("village_id", "");
        formik.setFieldValue("village_name", "");
        break;
      case "village_id":
        formik.setFieldValue(
          "village_name",
          villages.find((j) => j.village_id === +id)?.village
        );
        break;
      default:
    }
  };

  // const deleteAdvertiser = async (id1) => {
  //     try {
  //         await api({
  //             url: `/user/advertisers/${id1}`,
  //             method: "DELETE",
  //             responseType: "json"
  //         });
  //         Toast('success', "Advertiser Deleted Successfully");
  //         setCurrentPage(0);
  //         setSearch('');
  //         setStatus(-1);
  //         setAgency(-1);
  //         loadData(search, 0, status, agency);
  //     } catch (error) {
  //         let er = error?.response?.message || "Something went wrong"
  //         Toast("error", er)
  //         if (error.response.status === 401)
  //             navigate("/")
  //     }
  // }

  // useEffect(() => {
  // const timer = setTimeout(() => {
  // loadData(search, 0, status, agency);
  // }, 200);

  // return () => clearTimeout(timer);
  // }, []);

  // useEffect(() => {
  //     setCategoryId(category_id)
  // }, [])

  // useEffect(() => {
  //     setStateId(state_id)
  // }, [])

  // useEffect(() => {
  //     setDistId(district_id)
  // }, [])

  // useEffect(() => {
  //     setMandalId(mandal_id)
  // }, [])

  // useEffect(() => {
  //     setVillageId(village_id)
  // }, [])

  // useEffect(() => {
  //     loadData();

  // }, [currentPage]);

  const handleAdv = () => {
    setAdvType("");
    setView(true);
  };
  const handleInputChange = (e) => {
    setAdvType(e.target.value);
  };
  const handleAdvType = async () => {
    const advregex = /^[A-Za-z0-9][A-Za-z0-9!@#$%^&*()_+-=<>?/|}{~:]*/
    if (advtype.match(advregex)) {
      try {
        let res = await api({
          url: `/user/advertisers/addadvtype`,
          method: "POST",
          responseType: "json",
          data: { advtype },
        });
        if (res?.data?.code === 500) {
          Toast("error", res.data.message);
          // setAdvType("");
        } else {
          Toast("success", "Advertiser Type Added Successfully");
          handle();
          // getTypes();
          getCompanies();
          setView(false);
          // setAdvType("");
        }
      } catch (error) {
        let er = error?.response?.message || "Something went wrong";
        Toast("error", er);
        // setAdvType("");
        if (error.response.status === 401) navigate("/");
      }
    }
    else {
      Toast("error", "Advertiser Type can't start with special characters");
    }
  }

  const statusSearch = (e) => {
    setStatus(e.target.value);
    setCurrentPage(0);
    loadData(search, 0, e.target.value);
    setOtp({});
  };

  const agencySearch = (e) => {
    setAgency(e.target.value);
    setCurrentPage(0);
    loadData(search, 0, status, e.target.value);
  };

  const viewOTP = async (mobile, userType, index) => {
    try {
      let res = await api({
        url: `/user/sales_persons/viewOTP`,
        method: "POST",
        responseType: "json",
        data: {
          mobileno: mobile,
          type: userType,
        },
      });
      if (res?.code === 200) {
        const updatedOtpData = { ...otp };
        updatedOtpData[index] = res?.data?.length ? res?.data[0].otp : "OTP not found"
        setOtp(updatedOtpData);
        // Toast("success", "OTP displayed Successfully");
      } else {
        Toast("error", res.data.message);
        const updatedOtpData = { ...otp };
        updatedOtpData[index] = '';
        setOtp(updatedOtpData);
      }
    } catch (error) {
      let er = error?.response?.message || "Something went wrong";
      Toast("error", er);
      setOtp({})
      if (error.response.status === 401) navigate("/");
    }

  }
  const options = orderTablePermissions.map(permission => ({
    value: permission.value,
    label: permission.label
  }));
  return (
    <div>
      <div className="flex items-center gap-3 mb-3">
        <aside className="ml-auto flex items-center gap-3">
          <div className="w-40">
            <SlInput type="text"
              size="small"
              id="myInput"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search By Name / Email / Mobile / Type">
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            {/* <input
            type="text"
            id="myInput"
            className="form-control"
            onChange={debounce(searchData, 500)}
            placeholder="Search By Name / Email / Mobile.."
          /> */}
          </div>
          {/* <label className='col-sm-2'> Status:</label> */}
          <div>
            <SlSelect onSlChange={statusSearch} size="small" placeholder="All">
              <SlIcon library="lucide" name="activity" slot="prefix"></SlIcon>
              <SlOption value="-1">All </SlOption>
              <SlOption value="1">Active </SlOption>
              <SlOption value="0">Inactive </SlOption>
            </SlSelect>
            {/* <select
            name="status"
            className="form-select"
            onChange={statusSearch}
          >
            <option value="-1" key="-1">
              All
            </option>
            <option value="1" key="1">
              Active
            </option>
            <option value="0" key="0">
              Inactive
            </option>
          </select> */}
          </div>
          {/* <div>s */}
          {/* <SlSelect placeholder="All" size="small" onSlChange={agencySearch}>
              <SlIcon library="lucide" name="star" slot="prefix"></SlIcon>
              <SlOption value="-1">All</SlOption>
              <SlOption value="1">Agency</SlOption>
            </SlSelect> */}

            {/* <select
            name="agency"
            className="form-select"
            onChange={agencySearch}
          >
            <option value="-1" key="-1">
              All
            </option>
            <option value="1" key="1">
              Agency
            </option>
          </select> */}
          {/* </div> */}
          <div>
            <SlButton variant="primary" size="small" onClick={() => {
              handleShow("add", {});
              setFlag("add");
              // loadCategories();
              // getStates();
              // getTypes();
              getCompanies();
            }}>Add Advertiser</SlButton>
          </div>
        </aside>
      </div>
      <SlDrawer label={flag === "edit" ? "Edit Advertiser" : "Create Advertiser"} open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '640px' }}>

        <form onSubmit={formik.handleSubmit}>
          {/* <div className="mb-3">
            <div className="flex gap-4 items-center mb-3">
              <label>Advertiser Type <span className="text-red-600">*</span></label>
              <SlButton
                size="small"
                variant="primary"
                outline
                onClick={handleAdv}>Add New Type</SlButton>
            </div>
            <select
              className="form-select"
              aria-label="Default select example"
              name="advertiserType"
              placeholder="Select Advertiser Type"
              onBlur={formik.handleBlur}
              value={formik.values.advertiserType}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            >
              <option value="">Select Type</option>
              {types.map((item) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item.type}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.advertiserType ? (
              <div className="text-red-600	">
                {formik.errors.advertiserType}
              </div>
            ) : null}
          </div> */}

          <div className="mb-3">
            <label className="mb-1">
              {" "}
              Advertiser Name <span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Advertiser Name"
              aria-label=""
              name="advertiser_name"
              value={formik.values.advertiser_name}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.advertiser_name ? (
              <div className="text-red-600	">
                {formik.errors.advertiser_name}
              </div>
            ) : null}
          </div>

          <div className="mb-3">
            <label className="mb-1"> Mobile No <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Mobile No"
              aria-label=""
              name="mobile_no"
              value={formik.values.mobile_no}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.mobile_no ? (
              <div className="text-red-600	">{formik.errors.mobile_no}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label className="mb-1">Email <span className="text-red-600">*</span></label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter Email"
              aria-label=""
              name="email"
              value={formik.values.email}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.email ? (
              <div className="text-red-600	">{formik.errors.email}</div>
            ) : null}
          </div>

          {/* <div className="mb-3">
            <label className="mb-1"> Company Name <span className="text-red-600">*</span></label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Company Name"
              aria-label=""
              name="company_name"
              value={formik.values.company_name}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.company_name ? (
              <div className="text-red-600	">{formik.errors.company_name}</div>
            ) : null}
          </div> */}

          <div className="mb-3">
            <div className="flex gap-4 items-center mb-3">
              <label>Company Name <span className="text-red-600">*</span></label>
            </div>
            <select
              className="form-select"
              aria-label="Default select example"
              name="company_name"
              placeholder="Select Company"
              onBlur={formik.handleBlur}
              value={formik.values.company_name}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            >
              <option value="">Select Company</option>
              {companies.map((item) => {
                return (
                  <option value={item.company_id} key={item.company_id}>
                    {item.company_name}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.company_name ? (
              <div className="text-red-600	">
                {formik.errors.company_name}
              </div>
            ) : null}
          </div>

          <div className="mb-3">
            <div className="flex gap-4 items-center mb-3">
              <label>Permissions </label>
            </div>
            <Select
              isMulti
              options={options}
              name="permissions"
              className="basic-multi-select"
              classNamePrefix="select"
              value={selectedPermissions}
              onChange={(selectedOptions) => {
                setSelectedPermissions(selectedOptions)
              }}
            // onChange={(selectedOptions) => {
            //   const selectedPermissionsArray = selectedOptions.map(option => option.value);
            //   setSelectedPermissions(selectedPermissionsArray);
            // }}
            />
          </div>

          {/* <div className="mb-3">
            <label className="mb-1">GST NO</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter GST No"
              aria-label=""
              name="gst_no"
              value={formik.values.gst_no}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.gst_no ? (
              <div className="text-red-600	">{formik.errors.gst_no}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="mb-1">Pan NO</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter PAN No"
              aria-label=""
              name="pan_no"
              value={formik.values.pan_no}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.pan_no ? (
              <div className="text-red-600	">{formik.errors.pan_no}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="mb-1"> Account Number </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Account Number"
              aria-label=""
              name="Account_number"
              value={formik.values.Account_number}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.Account_number ? (
              <div className="text-red-600	">{formik.errors.Account_number}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="mb-1"> IFSC Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter IFSC code"
              aria-label=""
              name="Ifsc_code"
              value={formik.values.Ifsc_code}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.Ifsc_code ? (
              <div className="text-red-600	">{formik.errors.Ifsc_code}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="col-sm-2 col-form-label"> States </label>
            <select
              className="form-select"
              aria-label="Default select example"
              name="state_id"
              placeholder="Select State"
              onBlur={formik.handleBlur}
              value={formik.values.state_id}
              onChange={(e) => {
                formik.handleChange(e);
                getDistricts(e.target.value);
                onInputChange("state_id", e.target.value);
              }}
            >
              <option value="">Select State</option>
              {states.map((item) => {
                return (
                  <option value={item.state_id} key={item.state_id}>
                    {item.state_name}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.state_id ? (
              <div className="text-red-600	">{formik.errors.state_id}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="col-sm-2 col-form-label"> Districts </label>
            <select
              className="form-select"
              aria-label="Default select example"
              name="district_id"
              placeholder="Select Ditrict"
              onBlur={formik.handleBlur}
              value={formik.values.district_id}
              onChange={(e) => {
                formik.handleChange(e);
                getMandals(e.target.value);
                onInputChange("district_id", e.target.value);
              }}
            >
              <option value="">Select District</option>
              {districts.map((item) => {
                return (
                  <option value={item.dist_id} key={item.dist_id}>
                    {item.dist_name}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.district_id ? (
              <div className="text-red-600	">{formik.errors.district_id}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="col-sm-2 col-form-label"> Mandals </label>
            <select
              className="form-select"
              aria-label="Default select example"
              name="mandal_id"
              placeholder="Select Mandal"
              onBlur={formik.handleBlur}
              value={formik.values.mandal_id}
              onChange={(e) => {
                formik.handleChange(e);
                getVillages(e.target.value);
                onInputChange("mandal_id", e.target.value);
              }}
            >
              <option value="">Select Mandal</option>
              {mandals.map((item) => {
                return (
                  <option value={item.mandal_id} key={item.mandal_id}>
                    {item.mandal_name}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.mandal_id ? (
              <div className="text-red-600	">{formik.errors.mandal_id}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="col-sm-2 col-form-label"> Villages </label>
            <select
              className="form-select"
              aria-label="Default select example"
              name="village_id"
              placeholder="Select Village"
              onBlur={formik.handleBlur}
              value={formik.values.village_id}
              onChange={(e) => {
                formik.handleChange(e);
                onInputChange("village_id", e.target.value);
              }}
            >
              <option value="">Select Village</option>
              {villages.map((item) => {
                return (
                  <option value={item.village_id} key={item.village_id}>
                    {item.village}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.village_id ? (
              <div className="text-red-600	">{formik.errors.village_id}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="mb-1">Address</label>
            <input
              type="textarea"
              className="form-control"
              placeholder="Enter Address"
              aria-label=""
              name="address"
              value={formik.values.address}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.address ? (
              <div className="text-red-600	">{formik.errors.address}</div>
            ) : null}
          </div> */}

          {/* <div className="mb-3">
            <label className="col-sm-2 col-form-label"> category</label>
            <select
              className="form-select"
              aria-label="Default select example"
              name="category_id"
              placeholder="Select Category"
              onBlur={formik.handleBlur}
              value={formik.values.category_id}
              onChange={(e) => {
                formik.handleChange(e);
                onInputChange("category_id", e.target.value);
              }}
            >
              <option value="">Select Category</option>
              {category.map((item) => {
                return (
                  <option value={item.category_id} key={item.category_id}>
                    {item.category_name}
                  </option>
                );
              })}
            </select>
            {submit && formik.errors.category_id ? (
              <div className="text-red-600	">{formik.errors.category_id}</div>
            ) : null}
          </div> */}


          {/* <div className="mb-3 form-check">
            <label className="form-check-label">
              isAgency </label>
            <input
              type="checkbox"
              className="form-check-input"
              name="isagency"
              value={formik.values.isagency}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />

          </div> */}

          {/* {formik.values.isagency && (
            <div className="mb-3 ">
              <label className="col-sm-2 col-form-label">
                {" "}
                Commission(%){" "}<span className="text-red-600">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Commission"
                aria-label=""
                name="commission"
                value={formik.values.commission}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.commission ? (
                <div className="text-red-600	">{formik.errors.commission}</div>
              ) : null}
            </div>
          )} */}

          {flag === "edit" && (
            <div className="mb-3 form-check form-switch">
              <label className="form-check-label">
                Status ({formik.values.status ? "Active" : "Inactive"})
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={formik.values.status}
                onChange={() => {
                  formik.setFieldValue("status", formik.values.status ? 0 : 1);
                }}
              />
            </div>
          )}

          <div slot="footer">
            <SlButton
              type="submit"
              variant="primary"
              size="small"
              onClick={(e) => setSubmit(true)}>Submit</SlButton>
          </div>
        </form>
      </SlDrawer>
      {/* <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Advertiser</Modal.Title>
        </Modal.Header>
        <Modal.Body contentclassname="mymodal-height">
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <div className="d-flex justify-content-between mb-3">
                <label>{" "}Advertiser Type{" "}</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={handleAdv}
                  >
                    Add New Type
                  </button>
                </div>
              <select
                className="form-select"
                aria-label="Default select example"
                name="advertiserType"
                placeholder="Select Advertiser Type"
                onBlur={formik.handleBlur}
                value={formik.values.advertiserType}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              >
                <option value="">Select Type</option>
                {types.map((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item.type}
                    </option>
                  );
                })}
              </select>
              {submit && formik.errors.advertiserType ? (
                <div className="text-red-600	">
                  {formik.errors.advertiserType}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1"> Company Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Company Name"
                aria-label=""
                name="company_name"
                value={formik.values.company_name}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.company_name ? (
                <div className="text-red-600	">{formik.errors.company_name}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1">
                {" "}
                Advertiser Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Advertiser Name"
                aria-label=""
                name="advertiser_name"
                value={formik.values.advertiser_name}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.advertiser_name ? (
                <div className="text-red-600	">
                  {formik.errors.advertiser_name}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1"> Mobile No</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Mobile No"
                aria-label=""
                name="mobile_no"
                value={formik.values.mobile_no}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.mobile_no ? (
                <div className="text-red-600	">{formik.errors.mobile_no}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter Email"
                aria-label=""
                name="email"
                value={formik.values.email}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.email ? (
                <div className="text-red-600	">{formik.errors.email}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1">GST NO</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter GST No"
                aria-label=""
                name="gst_no"
                value={formik.values.gst_no}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.gst_no ? (
                <div className="text-red-600	">{formik.errors.gst_no}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1">Pan NO</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter PAN No"
                aria-label=""
                name="pan_no"
                value={formik.values.pan_no}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.pan_no ? (
                <div className="text-red-600	">{formik.errors.pan_no}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="col-sm-2 col-form-label"> States </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="state_id"
                placeholder="Select State"
                onBlur={formik.handleBlur}
                value={formik.values.state_id}
                onChange={(e) => {
                  formik.handleChange(e);
                  getDistricts(e.target.value);
                  onInputChange("state_id", e.target.value);
                }}
              >
                <option value="">Select State</option>
                {states.map((item) => {
                  return (
                    <option value={item.state_id} key={item.state_id}>
                      {item.state_name}
                    </option>
                  );
                })}
              </select>
              {submit && formik.errors.state_id ? (
                <div className="text-red-600	">{formik.errors.state_id}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="col-sm-2 col-form-label"> Districts </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="district_id"
                placeholder="Select Ditrict"
                onBlur={formik.handleBlur}
                value={formik.values.district_id}
                onChange={(e) => {
                  formik.handleChange(e);
                  getMandals(e.target.value);
                  onInputChange("district_id", e.target.value);
                }}
              >
                <option value="">Select District</option>
                {districts.map((item) => {
                  return (
                    <option value={item.dist_id} key={item.dist_id}>
                      {item.dist_name}
                    </option>
                  );
                })}
              </select>
              {submit && formik.errors.district_id ? (
                <div className="text-red-600	">{formik.errors.district_id}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="col-sm-2 col-form-label"> Mandals </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="mandal_id"
                placeholder="Select Mandal"
                onBlur={formik.handleBlur}
                value={formik.values.mandal_id}
                onChange={(e) => {
                  formik.handleChange(e);
                  getVillages(e.target.value);
                  onInputChange("mandal_id", e.target.value);
                }}
              >
                <option value="">Select Mandal</option>
                {mandals.map((item) => {
                  return (
                    <option value={item.mandal_id} key={item.mandal_id}>
                      {item.mandal_name}
                    </option>
                  );
                })}
              </select>
              {submit && formik.errors.mandal_id ? (
                <div className="text-red-600	">{formik.errors.mandal_id}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="col-sm-2 col-form-label"> Villages </label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="village_id"
                placeholder="Select Village"
                onBlur={formik.handleBlur}
                value={formik.values.village_id}
                onChange={(e) => {
                  formik.handleChange(e);
                  onInputChange("village_id", e.target.value);
                }}
              >
                <option value="">Select Village</option>
                {villages.map((item) => {
                  return (
                    <option value={item.village_id} key={item.village_id}>
                      {item.village}
                    </option>
                  );
                })}
              </select>
              {submit && formik.errors.village_id ? (
                <div className="text-red-600	">{formik.errors.village_id}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="mb-1">Address</label>
              <input
                type="textarea"
                className="form-control"
                placeholder="Enter Address"
                aria-label=""
                name="address"
                value={formik.values.address}
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
              />
              {submit && formik.errors.address ? (
                <div className="text-red-600	">{formik.errors.address}</div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="col-sm-2 col-form-label"> category</label>
              <select
                className="form-select"
                aria-label="Default select example"
                name="category_id"
                placeholder="Select Category"
                onBlur={formik.handleBlur}
                value={formik.values.category_id}
                onChange={(e) => {
                  formik.handleChange(e);
                  onInputChange("category_id", e.target.value);
                }}
              >
                <option value="">Select Category</option>
                {category.map((item) => {
                  return (
                    <option value={item.category_id} key={item.category_id}>
                      {item.category_name}
                    </option>
                  );
                })}
              </select>
              {submit && formik.errors.category_id ? (
                <div className="text-red-600	">{formik.errors.category_id}</div>
              ) : null}
            </div>

            <div className="mb-3 form-check">
              <label className="form-check-label">
                {" "}
                isAgency
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="isagency"
                  value={formik.values.address}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
              </label>
            </div>
            {formik.values.isagency && (
              <div className="mb-3 ">
                <label className="col-sm-2 col-form-label">
                  {" "}
                  Commission(%){" "}
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Commission"
                  aria-label=""
                  name="commission"
                  value={formik.values.commission}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
                {formik.errors.commission ? (
                  <div className="text-red-600	">{formik.errors.commission}</div>
                ) : null}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary"
              onClick={(e) => setSubmit(true)}
            >
              Submit
            </button>
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal> */}

      <SlDrawer label="Assign Sales Person" open={open} onSlAfterHide={handle} >
        <selectForm.Select
          aria-label="Select Sales Person"
          className="form-control mb-2"
          value={sales_id}
          onChange={(e) => {
            setSalesId(e.target.value);
          }}
        >
          <option value="-1" key="-1">
            Assign Sales
          </option>
          {sales.map((item) => {
            return (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            );
          })}
        </selectForm.Select>
        <SlButton type="reset" variant="primary" onClick={handleSalesSave}>
          Submit
        </SlButton>
      </SlDrawer>

      {/* <Modal show={open} onHide={handle}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Sales Person</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <selectForm.Select
            aria-label="Select Sales Person"
            className="form-control"
            value={sales_id}
            onChange={(e) => {
              setSalesId(e.target.value);
            }}
          >
            <option value="-1" key="-1">
              Assign Sales
            </option>
            {sales.map((item) => {
              return (
                <option value={item.value} key={item.value}>
                  {item.label}
                </option>
              );
            })}
          </selectForm.Select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handle}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSalesSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal> */}


      {/* <SlDrawer label="Add Advertiser Type" open={view} onSlAfterHide={handle} >
        <div className="mb-3">
          <label className="mb-1">Advertise Type <span className="text-red-600">*</span></label>
          <form class="inline-validation">
            <input
              className="form-control"
              placeholder="Enter Advertiser Type"
              name="adv_name"
              onChange={handleInputChange}
            /><br />
            <SlButton type="reset" variant="primary" onClick={handleAdvType}>
              Submit
            </SlButton>
          </form>
        </div>
      </SlDrawer> */}


      {/* <Modal show={view} onHide={handle}> 
        <Modal.Header closeButton>
          <Modal.Title>Add Advertiser Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Advertiser Type"
            aria-label=""
            name="adv_name"
            onChange={(e) => {
              setAdvType(e.target.value);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handle}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAdvType}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* <Modal show={display} onHide={handle}>
        <Modal.Header closeButton>
          <Modal.Title>Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            <div className="overflow-x-auto">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">State</th>
                    <th scope="col"> District</th>
                    <th scope="col">Mandal</th>
                    <th scope="col">Village</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{res.state_name || "-"}</td>
                    <td>{res.district_name || "-"}</td>
                    <td>{res.mandal_name || "-"}</td>
                    <td>{res.village_name || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handle}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}

      <div className="overflow-x-auto mb-4">
        <ScrollContainer>
          <table className='table table-bordered '>
            <thead className="sticky top-0  ">
              <tr>
                <th >Advertiser ID</th>
                <th >Name</th>
                {/* <th >Type</th> */}
                <th >Email</th>
                <th >Mobile</th>
                <th >Company Name</th>
                <th >Password</th>
                {/* <th >GST No</th>
                <th >PAN No</th>
                <th >Location</th>
                <th >Address</th>
                <th >Category </th>
                <th >IsAgency</th>
                <th >Commission(%)</th> */}
                <th >Reg Date</th>
                <th >Upd Date</th>
                <th >Status</th>
                <th >Created By</th>
                <th >Assigned To</th>
                <th>View OTP</th>
                <th >Actions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item, index) => {
                  return (
                    <tr key={item.adv_id} className="group/details hover:bg-slate-100">
                      <th scope="row" className="flex items-center justify-center text-center gap-2">
                          {item?.mc_actions?.length ?<button className="h-2 w-2 px-1 py-1 rounded-full bg-orange-300" title={`pending edit action by ${item?.mc_actions?.[0]?.mc_user_name}`} onClick={() => setSelectedMcId(item?.mc_actions?.[0]?.mc_id)}></button>: null}
                          <span>{item.advertiser_id}</span>
                      </th>
                      <td>{item.advertiser_name}</td>
                      {/* <td>{item.type || "-"}</td> */}
                      <td>{item.email || "-"}</td>
                      <td>{item.mobile_no}</td>
                      <td>{item.company_name}</td>
                      <td>{item.password}</td>
                      {/* <td>{item.gst_no || "-"}</td>
                      <td>{item.pan_no || "-"}</td> */}
                      {/* <td> */}
                      {/* <sl-tooltip content="View location">
                          <sl-icon-button
                            library="lucide"
                            name="view"
                            onClick={() => {
                              handleLocation(item);
                            }}></sl-icon-button>
                        </sl-tooltip> */}

                        {/* <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          handleLocation(item);
                        }}
                      >
                        View
                      </button> */}
                      {/* </td> */}
                      {/* <td>{item.address || "-"}</td>
                      <td>{item.category_name || "-"}</td>
                      <td>{item.isagency ? "true" : "false"}</td>
                      <td>{item.commission || "-"}</td> */}
                      <td>{formatDateWithTime(item.reg_date)}</td>
                      <td>{formatDateWithTime(item.upd_date)}</td>
                      <td>
                        <span className={item.status ? "full-badge text-center" : "unpaid-badge text-center"}>
                          {item.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>{item.user_name || "-"}</td>
                      <td>
                        {item.name || (
                          <sl-tooltip content="Assign SalesPerson">
                            <sl-icon-button
                              library="lucide"
                              name="user-plus"
                              onClick={() => {
                                loadSales();
                                handleSales();
                                setadvid(item.adv_id);
                              }}></sl-icon-button>
                          </sl-tooltip>
                        )}
                      </td>
                      <td>
                        {otp[index] ? ( // Check if OTP exists for this index
                          <span>{otp[index]}</span>
                        ) : (
                          <SlTooltip content="View OTP">
                            <SlIconButton
                              library="lucide"
                              name="eye"
                              onClick={() => viewOTP(item.mobile_no, "advertiser", index)}
                            ></SlIconButton>
                          </SlTooltip>
                        )}
                      </td>
                      <td>
                        <sl-tooltip content="Edit">
                          <sl-icon-button
                            library="lucide"
                            name="edit"
                            onClick={() => {
                              handleShow("edit", item);
                              setFlag("edit");
                              setadvid(item.adv_id);
                            }}></sl-icon-button>
                        </sl-tooltip>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="17" />
            ) : (
              <TableLoader colspan="17" />
            )}
          </table>
        </ScrollContainer>
      </div>
      <div className="flex justify-end">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}</div>
        <PendingRequestModal mc_id={selectedMcId} isOpen={!!selectedMcId} onClose={handleCloseModal} />
    </div>
  );
}

export default Advertiser;
